export default "__VITE_ASSET__xHywfA6___"